<template>
  <b-form-group
    label="Soyadı"
    label-for="surname"
  >
    <validation-provider
      #default="{ errors }"
      name="Soyadı"
      rules="required"
    >
      <b-form-input
        id="surname"
        v-model="dataItem.surname"
        placeholder="Soyadı"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'Surname',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['customerAccounts/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
